import AudioSource from '@/webgl/audio/AudioSource'

export default class AudioLibrary {
  _record: Record<string, AudioSource> = {}

  has(id: string): boolean {
    return this._record[id] !== undefined
  }

  add(id: string, source: AudioSource) {
    if (this.has(id)) throw new Error(`AudioLibrary: Audio source with id ${id} already exists`)
    this._record[id] = source
  }

  remove(id: string) {
    this._record[id].dispose()
    delete this._record[id]
  }

  get(id: string): AudioSource {
    if (!this.has(id)) throw new Error(`AudioLibrary: No audio source with id ${id}`)
    return this._record[id]
  }
}
